import {useNavigate} from 'react-router-dom'
import React, {useEffect, useState} from 'react'

import Header from '../../components/header/Header.jsx'
import ListItems from './listItems/ListItems.jsx'
import CartStepsButton from './cartStepsButton/CartStepsButton.jsx'
import Questions from './questions/Questions.jsx'
import DescriptionValues from './descriptionValues/DescriptionValues.jsx'

import {Snackbar} from '@mui/material'
import {
    getLocal,
    getSession,
    removeLocal,
    removeSession,
    setLocal,
    setSession
} from '../../hooks/useStorage/useStorage.jsx'
import {
    checkSalesModality,
    checkServiceArea,
    checkServiceRadius,
    findProductBySku,
    trackEventAnalytics,
    log,
    newOrderId,
    trackEventPixel,
    tokenizeCard,
    colors,
    trackPageView,
    formatItemsAnalytics,
    getStoreIdentifier,
    roundValues
} from '../../utils/utils.jsx'
import {
    DialogAddCard,
    DialogAddress,
    DialogCashback,
    DialogChange,
    DialogConfirmation,
    DialogDate,
    DialogDiscountCoupon,
    DialogListRoute,
    DialogLoading,
    DialogOrderConfirmation,
    DialogPaymentMethods,
    DialogProfile,
    DialogQuestions,
    DialogScheduledOrderType,
    DialogScheduledTimes,
    DialogSendingSuccess,
    DialogTypeLogin,
    DialogWarning
} from '../../components/dialogs/Dialogs.jsx'
import {
    getDiscountCoupon,
    sendRequest,
    sendLog,
    getCashback,
    setDiscountCoupon
} from '../../services/Apis.jsx'

import {isDebug, isEmpty} from 'react-lf-tools'


import {ShoppingCartContext} from '../../context/ShoppingCartContext'
import {
    general as textsGeneral,
    paymentMethods as textsPaymentMethods,
    shoppingCart as textsShoppingCart,
    itemBag as textsItemBag
} from '../../translate/Translate.jsx'
import moment from 'moment'
import {motion} from 'framer-motion'

import {detect} from 'detect-browser'

const tokens = ['', '30F038EC-1746-43A4-A616-B6F3B2DF7CFF', 'D9FD97B5-36AB-4C04-B4FF-EDEE764509ED', 'E55BA084-57F2-42D9-A62D-292BF73E1B59']
const authkey = import.meta.env.VITE_AUTHKEY
const idStore = import.meta.env.VITE_ID_STORE
const indexStore = import.meta.env.VITE_INDEX_STORE
const version = import.meta.env.VITE_VERSION_NAME

import './shoppingCart.scss'
import themeMui from "../../themeMui.jsx";
import {ThemeProvider} from "@mui/material/styles";

const ShoppingCart = () => {
    const navigate = useNavigate()
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [items, setItems] = useState([])
    const [discount, setDiscount] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const [deliveryFee, setDeliveryFee] = useState(0)
    const [total, setTotal] = useState(0)
    const [isAddItem, setAddItem] = useState('')
    const [answersQuestions, setAnswersQuestions] = useState([])
    const [restartButton, setRestartButton] = useState('')
    const [isVisibleAddress, setVisibleAddress] = useState(true)
    const [cashbackBonus, setCashbackBonus] = useState(0)
    const [cashback, setCashback] = useState({
        balance: 0,
        rescue: 0,
        cpf: ''
    })
    const [dialogQuestions, setDialogQuestions] = useState({
        open: false
    })
    const [dialogPaymentMethods, setDialogPaymentMethods] = useState({
        open: false
    })
    const [dialogChange, setDialogChange] = useState({
        open: false
    })
    const [dialogAddCard, setDialogAddCard] = useState({
        open: false
    })
    const [dialogAddress, setDialogAddress] = useState({
        open: false
    })
    const [dialogOrderConfirmation, setDialogOrderConfirmation] = useState({
        open: false
    })
    const [dialogProfile, setDialogProfile] = useState({
        open: false
    })
    const [dialogSendingSuccess, setDialogSendingSuccess] = useState({
        open: false
    })
    const [dialogLoading, setDialogLoading] = useState({
        open: false,
        message: ''
    })
    const [dialogDiscountCoupon, setDialogDiscountCoupon] = useState({
        open: false
    })
    const [dialogWarning, setDialogWarning] = useState({
        open: false,
        title: '',
        message: ''
    })
    const [dialogCashback, setDialogCashback] = useState({
        open: false
    })
    const [dialogScheduledOrderType, setDialogScheduledOrderType] = useState({
        open: false
    })
    const [dialogDateRoute, setDialogDate] = useState({
        open: false
    })
    const [dialogScheduledTimes, setDialogScheduledTimes] = useState({
        open: false
    })
    const [dialogTypeLogin, setDialogTypeLogin] = useState({
        open: false
    })
    const [dialogListTimes, setDialogListTimes] = useState({
        open: false,
        date: '',
        routes: []
    })
    const [dialogConfirmation, setDialogConfirmation] = useState({
        open: false,
        title: '',
        message: '',
        type: ''
    })
    const handleMessage = (message) => setSnackbar({
        open: true,
        message: message
    })

    const handleCloseSnackbar = () => setSnackbar({open: false})

    const handleClickDialogWarning = () => setDialogWarning({...dialogWarning, open: false})

    const handleCloseDialogCashback = () => setDialogCashback({...dialogCashback, open: false})

    const handleClickDialogCashback = rescue => {
        if (rescue <= 0) {
            removeSession('rescue')
        } else {
            setSession('rescue', rescue)
            deleteDiscountCoupon(true)
        }
        setCashback({...cashback, rescue: rescue})
        setRestartButton(new Date().getTime().toString())
        handleCloseDialogCashback()
    }

    const handleCloseDialogScheduledOrderType = () => setDialogScheduledOrderType({open: false})

    const handleClickDialogScheduledOrderType = type => {
        const address = getLocal('address', {})
        const takeawayOptions = getLocal('takeawayOptions', '')
        const deliveryMode = getLocal('deliveryMode', '')
        if (type === 'immediate') {
            setSession('scheduledOrderType', type)
            //removeSession('scheduledDate')
            removeSession('scheduledTime')
            handleCloseDialogScheduledOrderType()
        } else {
            if (isEmpty(deliveryMode) || (isEmpty(address) && isEmpty(takeawayOptions)))
                return setDialogAddress({open: true})
            setDialogScheduledTimes({open: true})
            handleCloseDialogScheduledOrderType()
        }
    }

    const handleClickDialogDate = (date) => {
        const modules = getLocal('modules')
        const scheduledday = getLocal('scheduledday', false)
        const weekDeliveryStore = getLocal('weekDeliveryStore', [])
        if ((modules !== 3 && modules !== 4) && (scheduledday)) {
            const openTime = weekDeliveryStore.reduce((min, item) => {
                return item.openTime < min ? item.openTime : min
            }, weekDeliveryStore[0].openTime)
            setSession('scheduledTime', openTime)
            setSession('scheduledDate', date)
            handleCloseDialogDate()
            handleClickNext()
            return
        }
        const weekDeliveryRoute = getLocal('weekDeliveryRoute', [])
        const currentDay = (moment(date).day() + 1)
        const currentTime = moment()
        const filterRoutes = (route, currentDay, currentTime) => {
            const routeTime = moment(date + ' ' + route.time, 'YYYY-MM-DD HH:mm:ss')
            const [hours, minutes] = route.limitTime.split(":").map(Number)
            const totalMinutes = hours * 60 + minutes
            routeTime.subtract(totalMinutes, 'minutes')
            return (route.day.includes(currentDay) && currentTime.isBefore(routeTime))
        }
        const routes = weekDeliveryRoute.filter(route => {
            return filterRoutes(route, currentDay, currentTime)
        })
        if (routes.length === 0) return handleMessage(textsGeneral.noRoutes)
        setDialogListTimes({open: true, date: date, routes: routes})
    }

    const handleCloseDialogDate = () => setDialogDate({open: false})

    const handleClickDialogScheduledTimes = (scheduledTime) => {
        setSession('scheduledOrderType', 'scheduled')
        setSession('scheduledTime', scheduledTime)
        handleCloseDialogScheduledTimes()
        handleClickNext()
    }

    const handleCloseDialogScheduledTimes = () => {
        const scheduledTime = getSession('scheduledTime')
        const deliveryMode = getLocal('deliveryMode', '')
        const openTakeWay = getLocal('openTakeWay', false)
        const openDelivery = getLocal('openDelivery', false)
        if (!deliveryMode || scheduledTime) return setDialogScheduledTimes({open: false})
        const shouldCloseDialogs = (deliveryMode === 'delivery' && !openDelivery) || (deliveryMode === 'takeaway' && !openTakeWay)
        if (shouldCloseDialogs) {
            setDialogScheduledTimes({open: false})
            setDialogOrderConfirmation({open: false})
        }
    }

    const handleClickDialogTypeLogin = (type) => {
        handleCloseDialogTypeLogin()
        if (type === 'without') {
            setDialogProfile({open: true})
        } else {
            navigate('/login')
        }
    }

    const handleCloseDialogTypeLogin = () => setDialogTypeLogin({open: false})

    const handleClickDialogListTimes = (date, time) => {
        setSession('scheduledOrderType', 'scheduled')
        setSession('scheduledTime', time.substring(0, 5))
        setSession('scheduledDate', date)
        handleCloseDialogDate()
        handleCloseDialogListTimes()
        handleClickNext()
    }

    const handleCloseDialogListTimes = () => setDialogListTimes({...dialogListTimes, open: false})

    const handleClickConfirmation = (type) => {
        if (type === 'needChange') {
            setDialogChange({open: true})
            setDialogConfirmation({open: false})
        }
    }

    const handleCloseConfirmation = (type) => {
        if (type === 'needChange') {
            setDialogConfirmation({open: false})
            setDialogPaymentMethods({open: false})
            setSession('payment', {code: 'DIN', description: 'Dinheiro', online: 'False'})
            removeSession('change')
            handleClickNext()
        }
    }

    const handleClickSendingSuccess = () => navigate('/', {replace: true})

    const handleChangeItem = item => {
        if (item.isCouponProduct) return
        const product = findProductBySku(item.sku)
        navigate('/produto', {
            state: {
                product: product,
                edit: true,
                item: item,
                isCouponProduct: false
            }
        })
    }

    const handleChangeQuantityItems = (item, type = 'add') => {
        try {
            const index_item = items.findIndex((i) => (i.id === item.id))
            if ((type === 'remove') && (item.amount === 1)) {
                items.splice(index_item, 1)
                deleteDiscountCoupon(true)
            } else {
                const amount = (type === 'add') ? (++item.amount) : (--item.amount)
                const subitemsValue = totalOfSubitems(item.subitems)
                items[index_item].amount = amount
                items[index_item].price = ((item.priceProduct + subitemsValue) * amount)
            }
            setAddItem(!isAddItem)
            setLocal('items', items)
            setItems(items)
            checkItems()
            checkDiscountPercentage()
        } catch (e) {
            log(e.message, 'error')
        }
    }

    const totalOfSubitems = (subitems) => {
        let total = 0
        subitems.forEach((subitem) => {
            total += subitem.sku.includes('S') ? (subitem.valuePercentage * subitem.amount) : (subitem.priceProduct * subitem.amount)
        })
        return total
    }

    const handleClickNext = async () => {
        const items = getLocal('items', [])
        const address = getLocal('address', {})
        const takeawayOptions = getLocal('takeawayOptions', '')
        const deliveryMode = getLocal('deliveryMode', '')
        const answersQuestions = getSession('answersQuestions', [])
        const questions = getLocal('questions', [])
        const payment = getSession('payment', [])
        const profile = getLocal('profile', {})
        const modules = getLocal('modules')
        const scheduled = getLocal('scheduled', false)
        const totem = getLocal('totem', false)
        const scheduledday = getLocal('scheduledday', false)
        const scheduledTime = getSession('scheduledTime', '')
        const scheduledDate = getSession('scheduledDate', '')
        const openDelivery = getLocal('openDelivery', false)
        const openTakeWay = getLocal('openTakeWay', false)
        const totalItems = getSession('totalItems', 0)
        if (!items.length) {
            navigate(-1)
        } else if (isEmpty(profile)) {
            if (totem) {
                setDialogProfile({open: true})
            } else {
                setDialogTypeLogin({open: true})
            }
        } else if (!isEmpty(questions) && isEmpty(answersQuestions)) {
            setDialogQuestions({open: true})
        } else if (isEmpty(deliveryMode) || (isEmpty(address) && isEmpty(takeawayOptions))) {
            setDialogAddress({open: true})
        } else if ((modules === 0 || modules === 1) && (deliveryMode === 'delivery') && (!openDelivery) && (scheduled) && (!scheduledTime)) {
            handleClickDialogScheduledOrderType('scheduled')
        } else if ((modules === 0 || modules === 2) && (deliveryMode === 'takeaway') && (!openTakeWay) && (scheduled) && (!scheduledTime)) {
            handleClickDialogScheduledOrderType('scheduled')
        } else if ((deliveryMode === 'delivery') && (modules === 3 || modules === 4) && (scheduledday) && (!scheduledTime || !scheduledDate)) {
            setDialogDate({open: true})
        } else if ((modules !== 3 || modules !== 4) && (scheduledday && !scheduledDate)) {
            setDialogDate({open: true})
        } else if (isEmpty(payment)) {
            setDialogPaymentMethods({open: true})
        } else {
            trackEventPixel('InitiateCheckout', {
                value: totalItems,
                currency: 'BRL'
            })
            trackEventAnalytics('begin_checkout', {
                currency: 'BRL',
                value: totalItems,
                items: formatItemsAnalytics(items)
            })
            setDialogOrderConfirmation({open: false})
            setDialogOrderConfirmation({open: true})
            await checkAddress()
        }
    }

    const checkValueDiscountCoupon = () => {
        const discountCoupon = getSession('discountCoupon', {})
        const value = discountCoupon.minimum_purchase || 0
        return {
            check: (value > total),
            value: value
        }
    }

    const handleCloseQuestions = () => setDialogQuestions({open: false})

    const handleConfirmQuestions = () => {
        handleCloseQuestions()
        handleClickNext()
    }

    const handleCloseDialogPaymentMethods = () => setDialogPaymentMethods({open: false})

    const handleChangeDialogPaymentMethods = () => setDialogConfirmation({
        open: true,
        title: textsPaymentMethods.change,
        message: textsPaymentMethods.doYouNeedChange,
        type: 'needChange'
    })

    const handleAddCardDialogPaymentMethods = () => setDialogAddCard({open: true})

    const handleClickChange = change => {
        setRestartButton(new Date().getTime().toString())
        setDialogPaymentMethods({open: false})
        setDialogChange({open: false})
        setSession('payment', {code: 'DIN', description: 'Dinheiro', online: 'False'})
        setSession('change', change)
        handleClickNext()
    }

    const handleCloseChange = () => {
        setDialogChange({open: false})
        setDialogPaymentMethods({open: false})
        setSession('payment', {code: 'DIN', description: 'Dinheiro', online: 'False'})
        removeSession('change')
        handleClickNext()
    }

    const handleCloseAddCard = () => {
        setDialogPaymentMethods({open: false})
        setDialogAddCard({open: false})
        handleClickNext()
    }

    const handleNextAddress = () => {
        setDialogAddress({open: false})
        handleClickNext()
    }

    const handleCloseAddress = () => {
        const takeawayOptions = getLocal('takeawayOptions')
        const address = getLocal('address', '')
        if (!takeawayOptions && !address) {
            setDialogAddress({open: false})
            setDialogOrderConfirmation({open: false})
        } else {
            setDialogAddress({open: false})
        }
    }

    const handleDeliveryFee = () => setDeliveryFee(0)

    const handleClickCashback = () => {
        const gularisMinimum = getLocal('gularisMinimum')
        if (cashback.balance < gularisMinimum) return setSnackbar({
            open: true,
            message: `${textsShoppingCart.minimumRescue} ${gularisMinimum.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })}`
        })
        setDialogCashback({...dialogCashback, open: true})
    }

    const deleteDiscountCoupon = (showMessage = true) => {
        const discountCoupon = getSession('discountCoupon', {})
        if (showMessage) if (!isEmpty(discountCoupon)) setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: textsShoppingCart.couponRemoved
        })
        const index = items.findIndex((fi) => fi.isCouponProduct)
        if (index !== -1) {
            items.splice(index, 1)
            setItems(items)
            setLocal('items', items)
            checkItems()
        }
        removeSession('discountCoupon')
        removeSession('discount')
        setDiscount(0)
        if (showMessage) setRestartButton(new Date().getTime().toString())
    }

    const handleCloseDiscountCoupon = () => setDialogDiscountCoupon({open: false})

    const handleRemoveDiscountCoupon = (showMessage) => {
        setDialogDiscountCoupon({open: false})
        deleteDiscountCoupon(showMessage)
    }

    const handleConfirmDiscountCoupon = async (discountCoupon) => {
        try {
            setDialogDiscountCoupon({open: false})
            if (totalItems === 0) return setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: textsShoppingCart.addItemsToUseTheCoupon
            })
            setDialogLoading({open: true, message: textsShoppingCart.checkingDiscountCoupon})
            const response = await getDiscountCoupon(discountCoupon)
            if (response.sucesso)
                checkTypesDiscountCoupon(response, discountCoupon)
            else setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: response.mensagem
            })
        } finally {
            setDialogLoading({open: false})
        }
    }

    const checkTypesDiscountCoupon = (response, discountCoupon) => {
        const {tipo_desconto: discount_type} = response
        switch (discount_type) {
            case 'DELIVERY_FEE':
                discountTypeDelivery(response, discountCoupon)
                break
            case 'VALUE':
                discountTypeValue(response, discountCoupon)
                break
            case'PERCENTAGE':
                discountTypePercentage(response, discountCoupon)
                break
            default:
                discountTypeProduct(response, discountCoupon)
                break
        }
    }

    const checkChange = () => {
        const change = getSession('change', 0)
        const changeValue = ((change) - (((totalItems + deliveryFee) - discount) - cashback.rescue))
        if (changeValue <= 0) removeSession('change')
    }

    const discountTypeDelivery = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase, primeira_compra, compra_unica} = response
        const deliveryMode = getLocal('deliveryMode')
        const deliveryFee = getLocal('deliveryFee')
        if (deliveryMode === 'takeaway') return setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: textsShoppingCart.deliveryCouponInvalidForTakeaway
        })
        if (totalItems >= parseFloat(minimum_purchase)) {
            setSession('discountCoupon', {
                type: 'DELIVERY_FEE',
                discountCoupon: discountCoupon,
                value: deliveryFee,
                minimum_purchase: minimum_purchase,
                firstPurchase: primeira_compra || false,
                singlePurchase: compra_unica || false
            })
            setSession('discount', deliveryFee)
            setDiscount(deliveryFee)
            removeCashback()
            setRestartButton(new Date().getTime().toString())
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const discountTypeValue = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase, valor: value, primeira_compra, compra_unica} = response
        if (totalItems >= parseFloat(minimum_purchase)) {
            setSession('discountCoupon', {
                type: 'VALUE',
                discountCoupon: discountCoupon,
                value: parseFloat(value),
                minimum_purchase: minimum_purchase,
                firstPurchase: primeira_compra || false,
                singlePurchase: compra_unica || false
            })
            setSession('discount', parseFloat(value))
            setDiscount(parseFloat(value))
            removeCashback()
            setRestartButton(new Date().getTime().toString())
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const discountTypePercentage = (response, discountCoupon) => {
        const {
            compra_minima: minimum_purchase,
            desconto_max: max_discount,
            valor: value,
            primeira_compra,
            compra_unica
        } = response
        if (totalItems >= parseFloat(minimum_purchase)) {
            const discountAmount = (totalItems * (parseFloat(value) / 100))
            const discount = ((discountAmount <= parseFloat(max_discount)) || (parseFloat(max_discount) === 0)) ? discountAmount : parseFloat(max_discount)
            setSession('discountCoupon', {
                type: 'PERCENTAGE',
                discountCoupon: discountCoupon,
                value: discount,
                minimum_purchase: parseFloat(minimum_purchase),
                max_discount: parseFloat(max_discount),
                percentage: parseFloat(value),
                firstPurchase: primeira_compra || false,
                singlePurchase: compra_unica || false
            })
            setSession('discount', discount)
            setDiscount(discount)
            removeCashback()
            setRestartButton(new Date().getTime().toString())
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const discountTypeProduct = (response, discountCoupon) => {
        const {compra_minima: minimum_purchase, valor: value, primeira_compra, compra_unica} = response
        if (totalItems >= parseFloat(minimum_purchase)) {
            const product = findProductBySku(value)
            if (isEmpty(product)) return setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: textsShoppingCart.productNotFound
            })
            if ((product.variations.length === 0) || !(product.variations.some((f) => (f.options.length > 1)))) {
                setSession('discountCoupon', {
                    type: 'FREE_PRODUCT',
                    discountCoupon: discountCoupon,
                    value: product.price,
                    minimum_purchase: parseFloat(minimum_purchase),
                    firstPurchase: primeira_compra || false,
                    singlePurchase: compra_unica || false
                })
                setSession('discount', product.price)
                setDiscount(product.price)
                addItem(product)
                removeCashback()
                setRestartButton(new Date().getTime().toString())
            } else {
                let valueDiscount = product.price
                product.variations.forEach((v) => {
                    if ((v.minSelection === 1 && v.maxSelection === 1) && (v.options.length === 1)) {
                        valueDiscount += v.options[0].price
                    }
                })
                setSession('discountCoupon', {
                    type: 'FREE_PRODUCT',
                    discountCoupon: discountCoupon,
                    value: valueDiscount,
                    minimum_purchase: parseFloat(minimum_purchase),
                    firstPurchase: primeira_compra || false,
                    singlePurchase: compra_unica || false
                })
                navigate('/produto', {
                    state: {
                        product: product,
                        edit: false,
                        item: {},
                        isCouponProduct: true
                    }
                })
                setRestartButton(new Date().getTime().toString())
            }
        } else {
            messageMinimumPurchase(minimum_purchase)
        }
    }

    const addItem = product => {
        const itemToCreate = {
            id: moment().toDate().getTime(),
            sku: product.sku,
            image: product.image,
            product: product.product,
            amount: 1,
            priceProduct: product.price,
            price: product.price,
            observation: '',
            subitems: [],
            datetime: moment().toDate(),
            isCouponProduct: true,
            version: import.meta.env.VITE_VERSION_NAME
        }
        items.push(itemToCreate)
        setItems(items)
        setLocal('items', items)
        checkItems()
    }

    const messageMinimumPurchase = (minimum_purchase) => setDialogWarning({
        open: true,
        title: textsGeneral.warning,
        message: `${textsShoppingCart.minimumPurchaseDiscountNotice} ${parseFloat(minimum_purchase).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        })}`
    })

    const handleCloseOrderConfirmation = () => setDialogOrderConfirmation({open: false})

    const handleEditOrderConfirmation = (type) => {
        switch (type) {
            case 'address':
                setDialogAddress({open: true})
                break
            case 'scheduled':
                checkEditSchedule()
                break
            case 'discountCoupon':
                setDialogDiscountCoupon({open: true})
                break
            case 'payment':
                setDialogPaymentMethods({open: true})
                break
            case 'cashback':
                handleClickCashback()
                break
            case 'questions':
                setDialogQuestions({open: true})
                break
            default:
                setDialogProfile({open: true})
                break
        }
    }

    const checkEditSchedule = () => {
        const modules = getLocal('modules')
        const deliveryMode = getLocal('deliveryMode')
        const openDelivery = getLocal('openDelivery', false)
        const openTakeaway = getLocal('openTakeWay', false)
        const scheduledday = getLocal('scheduledday', false)
        if (modules === 3 || modules === 4) {
            setDialogDate({open: true})
        } else {
            if (scheduledday) {
                setDialogDate({open: true})
                return
            }
            const isDelivery = deliveryMode === 'delivery'
            const isOpen = isDelivery ? openDelivery : openTakeaway
            setDialogScheduledOrderType({open: isOpen})
            if (!isOpen) {
                setDialogScheduledTimes({open: true})
            }
        }
    }

    const removeCashback = () => {
        const rescue = getSession('rescue', '')
        if (!!rescue) setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: textsShoppingCart.cashbackRemoved
        })
        removeSession('rescue')
        setCashback({...cashback, rescue: 0})
    }

    const handleClickOrderConfirmation = async () => {
        const reponseCoupon = checkValueDiscountCoupon()
        const purchaseMin = getLocal('purchaseMin', 0)
        const deliveryMode = getLocal('deliveryMode')
        const totalItems = getSession('totalItems', 0)
        if ((deliveryMode === 'delivery') && (totalItems < purchaseMin)) return setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: `${textsShoppingCart.minimumPurchase} ${purchaseMin.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })}`
        })
        setLocal('purchaseMin', purchaseMin)
        if (reponseCoupon.check) return setDialogWarning({
            open: true,
            title: textsGeneral.warning,
            message: `${textsShoppingCart.minimumPurchaseDiscountNotice} ${parseFloat(reponseCoupon.value).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })}`
        })
        const order = orderData()
        if (isDebug('5173') && import.meta.env.VITE_ID_STORE !== '123') {
            log(order)
            return
        }
        setDialogOrderConfirmation({open: false})
        setDialogLoading({open: true, message: textsShoppingCart.sendingRequest})
        console.log(order)
        const {returnCode, message} = await sendRequest(order)
        setDialogLoading({...dialogLoading, open: false})
        if (!!returnCode) {
            trackEventPixel('Purchase', {
                currency: 'BRL',
                value: order.total_produtos
            })
            trackEventAnalytics('purchase', {
                transaction_id: order.id_pedido,
                store_id: getStoreIdentifier(),
                currency: 'BRL',
                value: order.total,
                items: formatItemsAnalytics(order.itens)
            })
            invalidateCoupon()
            postOrderRecords(order)
            const request = requestLog(order)
            const log = await sendLog(request, 'POST')
            const updateOrder = {...order, logStatus: log || {}}
            setLocal('orderOld', updateOrder)
            recordHistory(updateOrder)
        } else {
            setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: message
            })
        }
    }

    const invalidateCoupon = () => {
        try {
            const coupon = getSession('discountCoupon', '')
            if (!!coupon?.discountCoupon) setDiscountCoupon(coupon.discountCoupon)
            setLocal(`coupon-${coupon.discountCoupon}`, 'queimado')
        } catch (e) {
            console.error(e.message)
        }
    }

    const requestLog = (order) => JSON.stringify({
        authkey_id: `${authkey}_${idStore}`,
        pedido: order,
        version: version,
        key: order.id_pedido,
    })

    const postOrderRecords = order => {
        setDialogSendingSuccess({open: true})
        setLocal('orderOld', order)
        removeSession('change')
        removeSession('discount')
        removeSession('payment')
        removeLocal('items')
        removeLocal('intervalID')
        removeSession('rescue')
        removeSession('answersQuestions')
        removeSession('scheduledOrderType')
        removeSession('scheduledTime')
        removeSession('scheduledDate')
        removeSession('discountCoupon')
        newOrderId()
    }

    const recordHistory = order => {
        const history = getLocal('history', [])
        history.unshift(order)
        setLocal('history', history)
    }

    const handleClickProfile = (profile, totem = false) => {
        const b = getLocal('profile', '')
        setDialogProfile({open: false})
        setLocal('profile', profile)
        if (totem) {
            setLocal('takeawayOptions', 'Retirar na loja para levar')
            setLocal('deliveryMode', 'takeaway')
            setLocal('idStore', import.meta.env.VITE_ID_STORE)
        }
        checkCashbackClient()
        if (!b) {
            handleClickNext()
        }
    }

    const handleCloseProfile = () => setDialogProfile({open: false})

    const orderData = () => {
        const idStore = getLocal('idStore', import.meta.env.VITE_ID_STORE)
        const isDelivery = (getLocal('deliveryMode') === 'delivery')
        const profile = getLocal('profile')
        const address = getLocal('address')
        const payment = getSession('payment')
        const orderId = getLocal('orderId', new Date().getTime().toString())
        const scheduledTime = getSession('scheduledTime', '')
        const scheduledDate = getSession('scheduledDate', '')
        const scheduledday = getLocal('scheduledday', false)
        const totalItems = getSession('totalItems', 0)
        const takeawayOptions = getLocal('takeawayOptions')
        const obs = !isDelivery ? takeawayOptions?.store || '' : ''
        const deliveryFee = getLocal('deliveryFee', 0)
        const discount = getSession('discount', 0)
        const rescue = getSession('rescue', 0)
        const change = getSession('change', 0)
        const totalOrder = (((totalItems + deliveryFee) - discount) - rescue)
        const discountCoupon = getSession('discountCoupon', '')
        const coupon = discountCoupon?.discountCoupon ?? ''
        const singlePurchase = discountCoupon?.singlePurchase ?? false
        const firstPurchase = discountCoupon?.firstPurchase ?? false
        const browser = detect() || {}
        const order = {
            authkey: authkey,
            buscar: !isDelivery,
            cliente: {
                cliente_cpf: profile.cpf,
                cliente_nome: profile.name,
                cliente_telefone: profile.phone,
                endereco_bairro: isDelivery ? address.neighborhood : '',
                endereco_cep: isDelivery ? address.zipCode : '',
                endereco_cidade: isDelivery ? address.city : '',
                endereco_complemento: isDelivery ? address.addressComplement : '',
                endereco_numero: isDelivery ? address.number : '',
                endereco_rua: isDelivery ? address.street : '',
                endereco_uf: isDelivery ? address.uf : '',
                endereco_lat: address?.latitude || 0,
                endereco_lon: address?.longitude || 0
            },
            cupomCompraUnica: singlePurchase,
            cupomPrimeiraCompra: firstPurchase,
            dataHora: dateTime(scheduledDate, scheduledTime),
            dataHoraEnvio: moment().format('YYYY-MM-DD HH:mm:ss'),
            desconto: roundValues(discount),
            entrega: roundValues(deliveryFee),
            expire: timeExpireOrder((payment.code === 'PIX')),
            gularis_desconto: roundValues(rescue),
            id_loja: idStore,
            id_pedido: orderId,
            itens: formatItems(),
            motivo_desconto: coupon,
            obs: obs,
            pagamentos: [
                {
                    bandeira: flag(),
                    ccc: ccc(payment, orderId),
                    codigo: code(payment),
                    titulo: payment.description,
                    valor: (!!change) ? roundValues(change) : roundValues(totalOrder)
                }
            ],
            pedidoPorRota: scheduledday,
            perguntas: formatQuestions(),
            retorno: {
                status: 'PENDENTE'
            },
            scheduled: !!scheduledTime,
            tipo_pedido: 'delivery',
            token: tokens[indexStore],
            total: roundValues(totalOrder),
            total_produtos: roundValues(totalItems),
            troco: roundValues(change),
            versao: version,
            device: browser
        }
        return order
    }

    const dateTime = (date, time) => {
        if (!!date) {
            return `${date} ${time}`
        } else if (!!time) {
            return moment(time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        } else {
            return moment().format('YYYY-MM-DD HH:mm:ss')
        }
    }

    const timeExpireOrder = (pix = false) => {
        return moment().add((pix) ? 15 : 120, 'minutes')
    }

    const formatItems = () => {
        const items = getLocal('items')
        const array = []
        items.forEach((it) => array.push({
            fracionado: false,
            hora: it.datetime,
            preco: it.price,
            precoProduto: it.priceProduct,
            quantidade: it.amount,
            sku: it.sku,
            titulo: it.product,
            subItens: formatSubItems(it.subitems),
            obs: it.observation,
            versao: it?.version || ''
        }))
        return array
    }

    const formatSubItems = (subItems) => {
        const array = []
        subItems.forEach((subitem) => array.push({
            preco: subitem.price,
            precoProduto: subitem.priceProduct,
            quantidade: subitem.amount,
            sku: subitem.sku,
            titulo: subitem.option,
            etapa: subitem?.step
        }))
        return array
    }

    const flag = () => {
        const card = getSession('card', {})
        if (isEmpty(card)) return null
        return card.type.toUpperCase()
    }

    const ccc = (payment, orderId) => {
        const card = getSession('card', {})
        if (payment.code !== 'ONLINE' || isEmpty(card)) return null
        return tokenizeCard(card, orderId)
    }

    const code = payment => {
        if (payment.description.toLowerCase() === 'pagamento online') {
            const card = getSession('card', {})
            const paymentTypes = getLocal('paymentTypes', [])
            for (let i = 0; paymentTypes.length; i++) {
                if ((paymentTypes[i].online === 'True') && (paymentTypes[i].description.toUpperCase().includes(card.type.toUpperCase()))) {
                    return paymentTypes[i].code
                }
            }
        }
        return payment.code
    }

    const formatQuestions = () => {
        const answersQuestions = getSession('answersQuestions', [])
        const a = []
        answersQuestions.forEach((it) => {
            a.push({
                interno: it.internal,
                pergunta: it.question,
                resposta: it.response
            })
        })
        return a
    }

    const checkItems = () => {
        try {
            const items = getLocal('items', [])
            const menu = getLocal('menuItems', [])

            const v1 = []
            items.forEach((item) => {
                const itemTime = moment(item.datetime).add(1, 'hour')
                const currentTime = moment()
                if (currentTime.isBefore(itemTime)) {
                    v1.push(item)
                }
            })

            const v2 = []
            v1.forEach((item) => {
                menu.forEach((menu) => {
                    menu.products.forEach((product) => {
                        if ((item.sku === product.sku) && (item.priceProduct === product.price)) {
                            v2.push(item)
                        }
                    })
                })
            })

            if ((items.length !== 0) && (v2.length === 0)) setSnackbar({
                open: true, message: textsShoppingCart.itemsRemovedFromCart
            })

            let totalItems = 0
            v2.forEach((item) => (totalItems += item.price))
            setTotalItems(totalItems)
            setSession('totalItems', totalItems)
            setItems(v2)
            setLocal('items', v2)
        } catch (e) {
            log(e.message, 'error')
        }
    }

    const checkTakeawayOptions = () => {
        try {
            const deliveryMode = getLocal('deliveryMode')
            if (deliveryMode !== 'takeaway') return
            const takeawayOptions = getLocal('takeawayOptions')
            if (!takeawayOptions?.id_loja) {
                removeLocal('deliveryMode')
                removeLocal('takeawayOptions')
            }
        } catch (e) {

        }
    }

    const checkSubitems = async () => {
        try {
            const items = getLocal('items', [])
            const filteredItems = items.filter(item =>
                item.subitems.every(subitem => subitem.hasOwnProperty('step')))
            if (items.length !== filteredItems.length) {
                setItems(filteredItems)
                setLocal('items', filteredItems)
                const menu = getLocal('menuItems')
                setSnackbar({open: true, message: textsShoppingCart.itemsRemovedFromCart})
            }
        } catch (e) {

        }
    }

    const checkAddress = async () => {
        try {
            const salesMessage = checkSalesModality()
            if (salesMessage) {
                setSnackbar({open: true, message: salesMessage})
            }
            const address = getLocal('address')
            const deliveryMode = getLocal('deliveryMode')
            if (isEmpty(address) || deliveryMode === 'takeaway') return
            const {attendance, deliveryFee, id_loja, message: serviceMessage} = checkServiceArea(address)
            const {
                isServiceRadius,
                exceededRadiusLimit,
                radiusDeliveryFee,
                latitude,
                longitude,
            } = await checkServiceRadius(address, false)
            if ((!address.latitude || !address.longitude) && latitude && longitude) {
                const updatedAddress = {...address, latitude, longitude}
                setLocal('address', updatedAddress)
                editRegisterAddress(updatedAddress)
            }
            if (!attendance && !isServiceRadius) {
                setSnackbar({open: true, message: serviceMessage})
                removeAddress()
                return
            }
            if (exceededRadiusLimit && !attendance) {
                removeAddress()
                return
            }

            const finalFee = isServiceRadius ? radiusDeliveryFee : deliveryFee
            setDeliveryFee(finalFee)
            setLocal('deliveryFee', finalFee)
            if (attendance) {
                setLocal('idStore', id_loja)
            }
        } catch (e) {
            alert(e.message)
        }
    }

    const removeAddress = () => {
        removeLocal('deliveryFee')
        removeLocal('address')
        removeLocal('deliveryMode')
        setVisibleAddress(false)
        setDeliveryFee(0)
    }

    const checkDiscountCoupon = () => {
        const items = getLocal('items', [])
        if (items.length === 0) return deleteDiscountCoupon(true)
        const discountCoupon = getSession('discountCoupon', {})
        const deliveryMode = getLocal('deliveryMode')
        const deliveryFee = getLocal('deliveryFee')
        if (!isEmpty(discountCoupon)) {
            if (discountCoupon.type === 'VALUE') {
                setSession('discount', discountCoupon.value)
                setDiscount(discountCoupon.value)
                removeCashback()
            } else if (discountCoupon.type === 'FREE_PRODUCT') {
                const isCouponProduct = items.some((item) => (item.isCouponProduct))
                if (isCouponProduct) {
                    setSession('discount', discountCoupon.value)
                    setDiscount(discountCoupon.value)
                    removeCashback()
                } else {
                    deleteDiscountCoupon(true)
                }
            } else if (discountCoupon.type === 'DELIVERY_FEE') {
                if ((deliveryMode === 'takeaway') || (deliveryFee === 0)) {
                    deleteDiscountCoupon(true)
                } else {
                    discountCoupon.value = deliveryFee
                    setSession('discountCoupon', discountCoupon)
                    setSession('discount', deliveryFee)
                    setDiscount(deliveryFee)
                    removeCashback()
                }
            } else if (discountCoupon.type === 'PERCENTAGE') {
                checkDiscountPercentage()
            }
        }
    }

    const checkFreeDelivery = async () => {
        try {
            const freeDelivery = getLocal('freeDelivery', 0)
            if (!freeDelivery) return

            const discountCoupon = getSession('discountCoupon', {})
            const currentCoupon = discountCoupon?.discountCoupon

            if (currentCoupon && currentCoupon !== 'freeDelivery') return

            const deliveryMode = getLocal('deliveryMode')
            if (deliveryMode !== 'delivery') {
                if (currentCoupon === 'freeDelivery') {
                    removeSession('discountCoupon')
                    removeSession('discount')
                    setDiscount(0)
                }
                return
            }

            const deliveryFee = getLocal('deliveryFee')
            if (!deliveryFee) return

            const totalItems = getSession('totalItems', 0)

            if (totalItems < freeDelivery && currentCoupon === 'freeDelivery') {
                removeSession('discountCoupon')
                removeSession('discount')
                return
            }

            if (totalItems >= freeDelivery) {
                const newDiscount = {
                    type: 'DELIVERY_FEE',
                    discountCoupon: 'freeDelivery',
                    value: deliveryFee,
                    minimum_purchase: freeDelivery,
                    firstPurchase: false,
                    singlePurchase: false
                }

                setSession('discountCoupon', newDiscount)
                setSession('discount', deliveryFee)
                setDiscount(deliveryFee)

                if (currentCoupon !== 'freeDelivery') {
                    setDialogWarning({
                        open: true,
                        title: textsGeneral.warning,
                        message: `Você ganha frete grátis em compras acima de ${freeDelivery.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })} reais.`
                    })
                }
            }
        } catch (e) {
            console.error('Erro ao verificar frete grátis:', e)
        }
    }

    const checkDiscountPercentage = () => {
        const discountCoupon = getSession('discountCoupon', {})
        if (!isEmpty(discountCoupon)) {
            const totalItems = getSession('totalItems')
            const discountAmount = (totalItems * (discountCoupon.percentage / 100))
            const discount = ((discountAmount <= discountCoupon.max_discount) || (discountCoupon.max_discount === 0)) ? discountAmount : discountCoupon.max_discount
            discountCoupon.value = discount
            setSession('discountCoupon', discountCoupon)
            setSession('discount', discount || 0)
            setDiscount(discount || 0)
            removeCashback()
        }
    }

    const checkCashbackClient = async () => {
        const profile = getLocal('profile', {})
        const gularisToken = getLocal('gularisToken', '')
        if (!isEmpty(profile) && !isEmpty(gularisToken)) {
            const rescue = getSession('rescue', 0)
            if (!!rescue) setCashback({...cashback, rescue: rescue})
            const result = await getCashback(profile.cpf, gularisToken)
            if (result.status === 'success') {
                setCashback({...cashback, balance: result.data.saldo, cpf: result.data.cpf, rescue: rescue})
            } else {
                setCashback({balance: 0, rescue: 0, cpf: ''})
                removeSession('rescue')
            }
        }
    }

    const checkSchedules = () => {
        const scheduledday = getLocal('scheduledday', false)
        if (!scheduledday) removeSession('scheduledDate')
    }

    useEffect(() => {
        async function fetchData() {
            checkItems()
            checkTakeawayOptions()
            await checkAddress()
            checkDiscountCoupon()
            checkCashbackClient()
            checkSchedules()
        }

        fetchData()
        trackPageView()
    }, [])

    const calculateTotal = () => {
        const total = (((totalItems + deliveryFee) - discount) - cashback.rescue)
        setTotal(total)
    }

    useEffect(() => {
        calculateTotal()
        checkChange()
    }, [totalItems, deliveryFee, discount, cashback])

    useEffect(() => {
        checkFreeDelivery()
    }, [totalItems, deliveryFee])


    const handlePressKeyboard = event => {
        if (event.key === 'Escape') {
            navigate(-1)
        } else if (event.key === 'F2') {
            setDialogDiscountCoupon({open: true})
        } else if (event.key === 'F8') {
            handleClickNext()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handlePressKeyboard, false)
        return () => document.removeEventListener('keydown', handlePressKeyboard, false)
    }, [])

    const styles = getLocal('colors')

    colors(document)

    return <ThemeProvider theme={themeMui(styles)}>
        <ShoppingCartContext.Provider
            value={{
                isAddItem,
                setAddItem,
                deliveryFee,
                totalItems,
                discount,
                setDiscount,
                answersQuestions,
                isVisibleAddress,
                setVisibleAddress,
                cashbackBonus,
                setAnswersQuestions,
                restartButton,
                setRestartButton,
                setDeliveryFee
            }}>
            <motion.div
                className={'shopping-cart'}
                initial={{x: 400}}
                animate={{x: 0}}
                transition={{duration: 0.3}}>
                <Header title={textsItemBag.title} buttonBack={true}/>
                <div className={'container-shopping-cart'}>
                    <ListItems
                        items={items}
                        clickItem={handleChangeItem}
                        clickQuantity={handleChangeQuantityItems}/>
                    <Questions
                        onClick={handleEditOrderConfirmation}/>
                    <DescriptionValues/>
                    <CartStepsButton
                        total={total}
                        clickNext={handleClickNext}/>
                </div>
                <>
                    <DialogQuestions
                        open={dialogQuestions.open}
                        onMessage={handleMessage}
                        onClose={handleCloseQuestions}
                        onConfirm={handleConfirmQuestions}
                    />
                    <DialogPaymentMethods
                        open={dialogPaymentMethods.open}
                        onClose={handleCloseDialogPaymentMethods}
                        onConfirm={handleChangeDialogPaymentMethods}
                        onNext={handleClickNext}
                        onAddCard={handleAddCardDialogPaymentMethods}
                    />
                    <DialogChange
                        open={dialogChange.open}
                        onMessage={handleMessage}
                        onClick={handleClickChange}
                        onClose={handleCloseChange}
                    />
                    <DialogAddCard
                        open={dialogAddCard.open}
                        onClose={handleCloseAddCard}
                    />
                    <DialogAddress
                        open={dialogAddress.open}
                        onNext={handleNextAddress}
                        onClose={handleCloseAddress}
                        onDeliveryFee={handleDeliveryFee}
                    />
                    {(dialogOrderConfirmation.open) && <DialogOrderConfirmation
                        open={dialogOrderConfirmation.open}
                        cashback={cashback}
                        onClose={handleCloseOrderConfirmation}
                        onEdit={handleEditOrderConfirmation}
                        onClick={handleClickOrderConfirmation}/>
                    }
                    {(dialogProfile.open) && <DialogProfile
                        open={dialogProfile.open}
                        onMessage={handleMessage}
                        viewLogout={false}
                        onClose={handleCloseProfile}
                        onClick={handleClickProfile}
                    />}
                    {(dialogDiscountCoupon.open) && <DialogDiscountCoupon
                        open={dialogDiscountCoupon.open}
                        onClose={handleCloseDiscountCoupon}
                        onRemove={handleRemoveDiscountCoupon}
                        onClick={handleConfirmDiscountCoupon}/>
                    }
                    <DialogWarning
                        open={dialogWarning.open}
                        title={dialogWarning.title}
                        message={dialogWarning.message}
                        onClick={handleClickDialogWarning}
                    />
                    {(dialogCashback.open) && <DialogCashback
                        open={dialogCashback.open}
                        cashback={cashback}
                        onMessage={handleMessage}
                        onClose={handleCloseDialogCashback}
                        onRemove={handleClickDialogCashback}
                        onClick={handleClickDialogCashback}
                    />}
                    <DialogScheduledOrderType
                        open={dialogScheduledOrderType.open}
                        onClose={handleCloseDialogScheduledOrderType}
                        onClick={handleClickDialogScheduledOrderType}
                    />
                    {(dialogDateRoute.open) && <DialogDate
                        open={dialogDateRoute.open}
                        onMessage={handleMessage}
                        onClick={handleClickDialogDate}
                        onClose={handleCloseDialogDate}
                    />}
                    <DialogScheduledTimes
                        open={dialogScheduledTimes.open}
                        onClick={handleClickDialogScheduledTimes}
                        onClose={handleCloseDialogScheduledTimes}
                    />
                    <DialogTypeLogin
                        open={dialogTypeLogin.open}
                        onClick={handleClickDialogTypeLogin}
                    />
                    <DialogListRoute
                        open={dialogListTimes.open}
                        routes={dialogListTimes.routes}
                        date={dialogListTimes.date}
                        onClick={handleClickDialogListTimes}
                        onClose={handleCloseDialogListTimes}
                    />
                    <DialogConfirmation
                        open={dialogConfirmation.open}
                        title={dialogConfirmation.title}
                        message={dialogConfirmation.message}
                        type={dialogConfirmation.type}
                        yesNot={true}
                        onClick={handleClickConfirmation}
                        onClose={handleCloseConfirmation}
                    />
                    <DialogLoading
                        open={dialogLoading.open}
                        message={dialogLoading.message}/>
                    {(dialogSendingSuccess.open) && <DialogSendingSuccess
                        open={dialogSendingSuccess.open}
                        onClick={handleClickSendingSuccess}/>}
                    <Snackbar
                        open={snackbar.open}
                        autoHideDuration={1600}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}/>
                </>
            </motion.div>
        </ShoppingCartContext.Provider>
    </ThemeProvider>
}

export default ShoppingCart
